var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCopyAndPaste(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 295,
    height: 295,
    viewBox: "0 0 295 295",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M245.833 110.625H135.208C121.631 110.625 110.625 121.631 110.625 135.208V245.833C110.625 259.41 121.631 270.417 135.208 270.417H245.833C259.41 270.417 270.416 259.41 270.416 245.833V135.208C270.416 121.631 259.41 110.625 245.833 110.625Z",
    stroke: "#433F3F",
    strokeWidth: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M61.4586 184.376H49.167C42.647 184.376 36.3942 181.786 31.7839 177.175C27.1736 172.565 24.5836 166.312 24.5836 159.792V49.1673C24.5836 42.6474 27.1736 36.3945 31.7839 31.7843C36.3942 27.174 42.647 24.584 49.167 24.584H159.792C166.312 24.584 172.565 27.174 177.175 31.7843C181.785 36.3945 184.375 42.6474 184.375 49.1673V61.459",
    stroke: "#004A8A",
    strokeWidth: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyAndPaste);
export default __webpack_public_path__ + "static/media/copy-and-paste.0de7e914de2639f926b65e347047e7ff.svg";
export { ForwardRef as ReactComponent };